import React from 'react';
import moment from 'moment';

import { MCButton, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, openApp, remCss } from 'src/helpers';
import model from '../model';
import cardModel from 'src/components/paymentCard/model';
import StripePaymentMethod from 'src/components/paymentCard/StripePaymentMethod';
import MasterCardImage from 'src/assets/images/cards/master.png';
import VisaCardImage from 'src/assets/images/cards/visa.png';

import StripeFormPayment from 'src/components/paymentCard/StripeFormPayment';
import AuthPopup from 'src/components/authPopup';
import { getStripePromise } from 'src/helpers/stripe';

const CHAT_TICKET_PAYMENT_ELEMENT_OPTIONS = {
  wallets: {
    applePay: 'never',
    googlePay: 'never',
    link: 'never'
  }
};

export default class ChatTicketPopup extends BaseComponent {
  state = { step: 'login', data: null };
  componentDidMount() {
    model.subscribe(this.subscription);
    cardModel.subscribe(this.subscription);
    getStripePromise();
    this.setState({ step: !model.isLogged ? 'login' : 'buyTicket', loading: false, data: null });
    model.createTicketPaymentIntent();
    cardModel.stripeList();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    cardModel.unsubscribe(this.subscription);
  }

  hide = () => {
    const { hide } = this.props;
    const { data } = this.state;
    const closePopup = () => {
      openApp({ action: 'chat', contactId: model.state.contact?.id, sid: data?.sid });
      hide();
    };

    if (this.state.step === 'card') {
      this.setState({ step: 'buyTicket' }, closePopup);
      return;
    }

    closePopup();
  };

  buyTicket = () => {
    model.buyTicket(this.getActiveCard()?.id, (err, res, success) => {
      if (success && res?.ticket) {
        this.hide();
      } else {
        if (success && res.chargeResult && !res.chargeResult.success) {
          this.setState({ step: 'card' });
        }
      }
    });
  };

  getActiveCard = () => {
    return this.state.card || cardModel.activeCard;
  };

  renderBuyTicket = () => {
    const { closeBtn } = this.props;
    let { charge } = model.getState();
    if (!charge) charge = { duration: 0, extraMessage: 0, messagesCount: 0, price: 0 };
    let card = this.getActiveCard();

    return (
      <>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('Chat ticket')}</div>
          {closeBtn}
        </div>
        <div className={'mc-flex-15-col'}>
          <div className={'mc-flex'}>
            <div className={'mc-label-416'}>
              {lang.t(
                `To connect with the doctor, please purchase a chat ticket. 
                This helps us ensure dedicated time for your consultation 
                and you can call if the doctor is available.`
              )}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label-416'}>{lang.t('Chat ticket will cost you:')}</div>
            <div className={'mc-value-716'}>
              {charge.price} {charge.currency}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label-416 mc-grow'}>
              - {charge.duration} {lang.t('days')}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label-416 mc-grow'}>
              - {charge.messagesCount} {lang.t('messages')}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label-416 mc-grow'}>
              {lang.t('Expires on')}{' '}
              {moment(Date.now() + charge.duration * 1000 * 60 * 60 * 24).format('MMM D')}
            </div>
          </div>
        </div>
        <div className={'mc-mt20'}>
          <div className={'mc-flex'}>
            <div className={'mc-grow'} />
            <div className={'mc-flex-10'}>
              <img src={MasterCardImage} style={{ height: remCss(30) }} />
              <img src={VisaCardImage} style={{ height: remCss(30) }} />
            </div>
          </div>
          {!!card && (
            <div className=' mc-flex mc-mt20 mc-ai-center'>
              <div className='mc-grow'>
                <StripePaymentMethod data={{ ...card, active: true }} small short />
              </div>
              <div
                data-testid='chat-ticket-change-card'
                className={'mc-link-418'}
                onClick={() => this.setState({ step: 'selectCard' })}
              >
                {lang.t('Change')}
              </div>
            </div>
          )}
        </div>
        {this.renderFooter()}
      </>
    );
  };

  newCard = () => {
    this.setState({
      selectingCard: { id: 'new' },
      card: { id: 'new' },
      step: 'card'
    });
  };

  renderSelectCards() {
    const activeCard = this.state.selectingCard || this.getActiveCard();
    let cards = cardModel.state.cards || [];
    let { error } = model.getApiState('buyTicket');

    return (
      <>
        <div className='mc-modal-header mc-flex'>
          <div className='mc-popup-title mc-grow'>{lang.t('Select Card')}</div>
          <MCButton
            style={{ minWidth: 150 }}
            primary
            large
            light
            radius
            small
            outline
            onClick={this.newCard}
            label={lang.t('New card')}
          />
        </div>
        <div style={{ overflow: 'auto' }}>
          <div className={'mc-flex-15-col'}>
            {cards.map((card, index) => (
              <div
                key={card.id + '_' + index}
                style={{ overflow: 'hidden' }}
                className={
                  activeCard?.id === card.id
                    ? 'mc-b-primary mc-radius-10'
                    : 'mc-b2-light mc-radius-10'
                }
              >
                <StripePaymentMethod
                  small
                  gap={10}
                  data={{ ...card, active: activeCard?.id === card.id }}
                  onClick={() => this.setState({ selectingCard: card })}
                />
              </div>
            ))}
          </div>
        </div>
        {!!error && (
          <div className={'mc-flex'}>
            <div className={'mc-error mc-grow'}>{error}</div>
          </div>
        )}
        <div className='mc-modal-footer mc-flex'>
          <div className={'mc-grow'} />
          <MCButton
            small
            primary
            light
            radius
            type={'button'}
            onClick={() => this.setState({ step: 'buyTicket', selectingCard: null })}
            label={lang.t('Back')}
          />
          <MCButton
            small
            primary
            dark
            radius
            type={'button'}
            onClick={() => {
              let card = this.state.selectingCard ||
                this.state.card ||
                cardModel.activeCard || { id: 'new' };
              this.setState({
                step: 'buyTicket',
                selectingCard: null,
                card
              });
              cardModel.stripeActive(card);
            }}
            label={lang.t('Select')}
          />
        </div>
      </>
    );
  }

  renderFooter = () => {
    let { error, loading } = model.getApiState('buyTicket');
    return (
      <>
        {!!error && (
          <div className={'mc-flex'}>
            <div className={'mc-error mc-grow'}>{error}</div>
          </div>
        )}
        <div className='mc-modal-footer mc-flex'>
          <div className={'mc-grow'} />
          <MCButton small primary light radius type={'button'} onClick={this.hide}>
            {lang.t('Cancel')}
          </MCButton>
          <MCButton
            small
            primary
            dark
            radius
            type={'button'}
            onClick={this.buyTicket}
            disabled={loading}
          >
            {!loading ? lang.t('Buy ticket') : lang.t('Loading...')}
          </MCButton>
        </div>
      </>
    );
  };

  render() {
    const { closeBtn } = this.props;
    let { clientSecret } = model.getState();
    let step = this.state.step;
    const popupCloseBtn = closeBtn ? React.cloneElement(closeBtn, { onClose: this.hide }) : null;

    return (
      <div
        className={'mc-popup-contain'}
        style={{
          width: remCss(500),
          overflow: step === 'selectCard' ? 'initial' : 'auto'
        }}
      >
        {step === 'loading' && (
          <div className={'mc-m-auto'}>
            <Spinner />
          </div>
        )}
        {step === 'login' && (
          <AuthPopup
            role={'patient'}
            closeBtn={popupCloseBtn}
            hide={this.hide}
            onlyContent={true}
            afterAuth={(isSignup, data) => {
              this.setState({ step: 'loading', data, isSignup });
              setTimeout(() => {
                model.getTicket(model.state.contact, () => {
                  if (model.isChatAvailable()) this.hide();
                  else this.setState({ step: 'buyTicket' });
                });
              }, 100);
            }}
          />
        )}
        {step === 'buyTicket' && this.renderBuyTicket()}
        {step === 'selectCard' && this.renderSelectCards()}
        {step === 'card' && (
          <StripeFormPayment
            key={clientSecret || 'chat-ticket-stripe-form'}
            model={model}
            options={{ clientSecret }}
            paymentElementOptions={CHAT_TICKET_PAYMENT_ELEMENT_OPTIONS}
            clientSecret={clientSecret}
            // createPaymentIntent={model.createTicketPaymentIntent}
            confirmPaymentIntent={model.confirmTicketPaymentIntent}
            closeBtn={popupCloseBtn}
            hide={this.hide}
            onlyContent={true}
            afterSave={() => {
              this.hide();
            }}
          />
        )}
      </div>
    );
  }
}
